// dependencies
import { Map } from "immutable";

export const getPageUISelector = (state) => state.page.get("CompanyGoalsList", Map());

/** Retuns the running job id, null if no job */
export const getCsvDownloadJobID = (state) => getPageUISelector(state).get("downloadCsvJobID", null);
